(() => {
  const initialize = (accordion) => {
    if (!(accordion instanceof HTMLElement) || accordion.dataset.tenpmReady === 'true') return;

    const trigger = accordion.querySelector(':scope > .tenpm-accordion__trigger');
    const panel = accordion.querySelector(':scope > .tenpm-accordion__panel');
    if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    accordion.dataset.tenpmReady = 'true';
    trigger.addEventListener('click', () => {
      const open = accordion.dataset.open !== 'true';
      accordion.dataset.open = String(open);
      trigger.setAttribute('aria-expanded', String(open));
      panel.toggleAttribute('inert', !open);
    });
  };

  const initializeAll = (root = document) => {
    if (root instanceof Element && root.matches('.tenpm-accordion')) initialize(root);
    root.querySelectorAll?.('.tenpm-accordion').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
